import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import AdminHeader from "./AdminHeader";
import { API_URL } from "./config";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const EditContact = () => {

    const [contact_name, setName] = useState('');
    const [contact_surname, setSurname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [client_id] = useState(localStorage.getItem('async_client_profile_id'));
    const { id } = useParams();
    let [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const role = localStorage.getItem('async_role');
        if (role === 'Admin') {
            setIsAdmin(true);
        }
        if (role === '' || role === null) {
            window.location.href = '/';
        }

        console.log(id);

        fetch(`${API_URL}/contacts/${id}`).then(res => {
            return res.json()
        }).then(resp => {
            setName(resp[0].contact_name);
            setSurname(resp[0].contact_surname);
            setPhone(resp[0].phone);
            setEmail(resp[0].email);
        }).catch((err) => {
            console.log(err.message);
        })
    }, [])

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        const userObj = { id, phone, email, client_id, contact_name, contact_surname };
        console.log(userObj);

        fetch(`${API_URL}/contacts/${id}`, {
            method: "PUT",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(userObj)
        }).then(res => {
            Swal.fire({
                text: "updated successfully!",
                icon: "success"
            });
            navigate('/Contacts');
        }).catch((err) => {
            console.log(err.message)
        })
    }

    return (
        <html>
            {isAdmin ? <AdminHeader /> : null}
            {/* {!isAdmin ? <Header /> : null} */}
            <body class="sb-nav-fixed">

                <div id="layoutSidenav">

                    <div id="layoutSidenav_content">
                        <main>
                            <div class="container-fluid px-4">
                                {/* <h1 class="mt-4">Create User</h1> */}
                                <ol class="breadcrumb mb-4">
                                    <li class="breadcrumb-item active"></li>
                                </ol>
                                <form className="container" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="offset-lg-3 col-lg-6">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2>Add Contact</h2>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-group">
                                                        <label style={{ float: "left" }}>Name</label> <br></br>
                                                        <input type="text" value={contact_name} onChange={e => setName(e.target.value)} className="form-control" /><br></br>
                                                    </div>
                                                    <div className="form-group">
                                                        <label style={{ float: "left" }}>Surname</label> <br></br>
                                                        <input type="text" value={contact_surname} onChange={e => setSurname(e.target.value)} className="form-control" /><br></br>
                                                    </div>
                                                    <div className="form-group">
                                                        <label style={{ float: "left" }}>Phone</label> <br></br>
                                                        <input type="text" value={phone} onChange={e => setPhone(e.target.value)} className="form-control" /><br></br>
                                                    </div>
                                                    <div className="form-group">
                                                        <label style={{ float: "left" }}>Email</label> <br></br>
                                                        <input type="text" value={email} onChange={e => setEmail(e.target.value)} className="form-control" /><br></br>
                                                    </div>
                                                </div>
                                                <div className="card-footer">
                                                    <button type="submit" className="btn btn-success" style={{ float: "left" }}>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>
            </body>
        </html>
    );
}

export default EditContact;